import styled from "styled-components";

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	p {
		font-size: 14px;
		font-weight: 700;
		color: #31475a;
	}

	button {
		background: transparent;
		border: none;
		cursor: pointer;
	}
`;

export const Separator = styled.div`
	width: 100%;
	height: 1px;
	background: #e5e5ea;
	margin: 32px auto;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 32px;

	button:first-child {
		background: transparent;
		border: 1px solid #504c9a;
		padding: 8px 32px;
		color: #504c9a;
		font-size: 16px;
		font-weight: bold;
	}

	button:last-child {
		background: #504c9a;
		border: 1px solid #504c9a;
		padding: 8px 32px;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
	}

	button {
		border-radius: 8px;

		&:disabled {
			background: #f2f4f7;
			border: 1px solid #f2f4f7;
			color: #dddddd;
			cursor: not-allowed;
		}
	}
`;
